module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("To my husband, who stormed out of the room after his precious Georgia Bulldogs lost their game, too angry to bother turning off ESPN in the midst of his tantrum. Hours later, I noticed men’s professional beach volleyball on the screen and was instantly sucked into the hot, sandy action, thereby inspiring this story. Thanks, love!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0